module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/pseudo-progress.html -->\n<div class="progress" data-nx-control="pseudo-progress">\n  <div\n    class="progress-bar"\n    role="progressbar"\n    aria-valuenow="0"\n    aria-valuemin="0"\n    aria-valuemax="100"\n    style="width: 0%;"\n    data-nx-control="progress-bar"\n  >\n    <span class="sr-only"></span>\n  </div>\n</div>\n';
}
return __p;
};
